export function applyMarketChanges(market, updatedMarket) {
    market.id = updatedMarket.id;
    market.name = updatedMarket.name;
    market.betslipLine = updatedMarket.betslipLine;
    market.marketType = updatedMarket.marketType;
    market.selections = updatedMarket.selections;
    market.eventId = updatedMarket.eventId;
    market.isSuspended = updatedMarket.isSuspended;
    market.liveData = updatedMarket.liveData;
    market.metadata = updatedMarket.metadata;
}
//# sourceMappingURL=applyMarketChanges.js.map